import React, { useEffect, useState } from "react";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import RealgemsSidebar from "../../realgems/RealgemsSidebar";
import "./ManualOperacoes.css";

const formatDateTime = (value) => {
  if (!value) return "";

  try {
    return new Intl.DateTimeFormat("pt-BR", {
      dateStyle: "short",
      timeStyle: "short",
    }).format(new Date(value));
  } catch (_err) {
    return String(value);
  }
};

const Apresentacoes = ({ realgems = false }) => {
  const [menuClose, setMenuClose] = useState(false);
  const [presentationsUrl, setPresentationsUrl] = useState("");
  const [presentationsUpdatedAt, setPresentationsUpdatedAt] = useState("");
  const [loading, setLoading] = useState(true);

  const toggleMenu = () => {
    setMenuClose((prev) => !prev);
  };

  useEffect(() => {
    let mounted = true;

    const loadPresentations = async () => {
      try {
        setLoading(true);
        const response = await Api.get("/public/presentations");
        const settings = response?.data?.settings || {};
        const nextUrl = String(settings.embedUrl || "").trim();

        if (!mounted) return;
        setPresentationsUrl(nextUrl);
        setPresentationsUpdatedAt(String(settings.updatedAt || "").trim());
      } catch (err) {
        console.error("Erro ao carregar apresentações:", err);

        if (!mounted) return;
        setPresentationsUrl("");
        setPresentationsUpdatedAt("");
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    loadPresentations();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="app-container">
      {realgems ? (
        <RealgemsSidebar close={menuClose} presentationsActive="active" />
      ) : (
        <Sidebar close={menuClose} presentationsActive="active" />
      )}

      <main className="main-content">
        <Topbar page="Apresentações" onToggleMenu={toggleMenu} />

        <section className="manual-card">
          <div className="manual-card-header">
            <div>
              <h1 className="manual-card-title">Apresentações</h1>
              <p className="manual-card-description">
                Consulte as apresentações configuradas pelo super administrador diretamente no
                sistema.
              </p>
              {presentationsUpdatedAt ? (
                <p className="manual-card-meta">
                  Atualizado em {formatDateTime(presentationsUpdatedAt)}
                </p>
              ) : null}
            </div>
          </div>

          {loading ? (
            <div className="manual-empty-state">Carregando apresentações...</div>
          ) : presentationsUrl ? (
            <div className="manual-frame-wrapper">
              <iframe
                className="manual-frame"
                src={presentationsUrl}
                title="Apresentações"
                scrolling="no"
                frameBorder="0"
                allowTransparency
                allowFullScreen
              />
            </div>
          ) : (
            <div className="manual-empty-state">
              Nenhuma apresentação configurada no momento. Procure o super administrador.
            </div>
          )}
        </section>
      </main>
    </div>
  );
};

export default Apresentacoes;
